import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'
import OrganizationService from '@forwardflow/services/OrganizationService'

import { PaginationQueryParams } from '@forwardflow/types'
import useSWR from 'swr'

export const useOrganizationUsers = (queryParams: PaginationQueryParams) => {
   const response = useSWR(
      [QUERY_KEYS.ORGANIZATION_USERS, { ...queryParams }],
      () => OrganizationService.getOrganizationUsersLists(queryParams),
      {
         shouldRetryOnError: false,
      }
   )
   return {
      ...response,
      mutate: () => response.mutate()
   }
}

export { useOrganizationUsersInfinite } from './useOrganizationUsersInfinite'
